module.exports = __webpack_public_path__ + "static/security_support.8e3cd2ec.png";